import React from "react";
import Banner from "../../assets/img/about-us.png";
import CustomBanner from "../../components/CustomBanner";
import { Helmet } from "react-helmet";

const Camera = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Helmet>
        <title>
          CCTV Kamera Aydınlatma Metni - LENSA
        </title>
        <meta
          name="description"
          content="CCTV Kamera Aydınlatma Metnini bu sayfayı ziyaret ederek inceleyebilirsiniz."
        />
      </Helmet>
      <CustomBanner
        title="CCTV Kamera Aydınlatma Metni"
        breadTitle="CCTV Kamera Aydınlatma Metni"
        image={Banner}
      />
      <div className="container mx-auto bg-white p-8 rounded-lg shadow-lg">
        <h1 className="text-2xl font-bold mb-6">
          CCTV KAMERA AYDINLATMA METNİ
        </h1>

        <p className="mb-4">
          Aşağıda yer alan Kişisel Verilerin İşlenmesine İlişkin Aydınlatma
          Metni’ni okuyarak kişisel verilerinizi işleme amaçlarımızı ve bu
          kapsamda haklarınızı ayrıntılarıyla incelemenizi rica ediyoruz.
        </p>

        <h2 className="text-xl font-semibold mb-4">a) Veri Sorumlusu</h2>
        <p className="mb-6">
          6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) uyarınca,
          kişisel verileriniz; veri sorumlusu olarak{" "}
          <strong>
            LENSA Sanayi ve Ticaret Anonim Şirketi
          </strong>{" "}
          (“Şirket”) tarafından aşağıda açıklanan kapsamda işlenmektedir.
        </p>

        <h2 className="text-xl font-semibold mb-4">
          b) Kişisel Verilerin İşlenme Amaçları, Toplama Yöntemleri ve Hukuki
          Sebepleri
        </h2>
        <table className="table-auto w-full mb-6 border-collapse border border-gray-300">
          <thead className="bg-gray-200">
            <tr>
              <th className="border border-gray-300 p-2 text-left">
                İşlemeye Konu Kişisel Veri Kategorileri ve Tipleri
              </th>
              <th className="border border-gray-300 p-2 text-left">
                Kişisel Verilerinizin Hangi Amaçlarla İşleneceği
              </th>
              <th className="border border-gray-300 p-2 text-left">
                Kişisel Verilerinizin Hangi Yöntemle Toplandığı ve Hukuki Sebebi
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-gray-300 p-2">
                Görsel ve İşitsel Kayıtlar: CCTV Kamera Kaydı
              </td>
              <td className="border border-gray-300 p-2">
                Fiziksel mekan güvenliğinin temini
              </td>
              <td className="border border-gray-300 p-2">
                CCTV Kameralar üzerinden otomatik olarak toplanan kişisel
                verileriniz KVKK’nın 5. maddesinde belirtilen "İlgili kişinin
                temel hak ve özgürlüklerine zarar vermemek kaydıyla, veri
                sorumlusunun meşru menfaatleri için veri işlenmesinin zorunlu
                olması" hukuki sebebine dayanılarak işlenmektedir.
              </td>
            </tr>
          </tbody>
        </table>

        <h2 className="text-xl font-semibold mb-4">
          c) İşlenen Kişisel Verilerinizin Kimlere ve Hangi Amaçlarla
          Aktarılabileceği
        </h2>
        <p className="mb-6">
          Kişisel verileriniz; aşağıda yer verilen üçüncü taraflara ve
          belirtilen amaçlarla aktarılabilecektir:
        </p>
        <table className="table-auto w-full mb-6 border-collapse border border-gray-300">
          <thead className="bg-gray-200">
            <tr>
              <th className="border border-gray-300 p-2 text-left">
                Yurt içinde Yerleşik Üçüncü Taraf
              </th>
              <th className="border border-gray-300 p-2 text-left">
                Aktarıma Konu Olabilecek Kişisel Veri Kategorileri ve Tipleri
              </th>
              <th className="border border-gray-300 p-2 text-left">
                Aktarım Amacı
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-gray-300 p-2">
                Yetkili kamu kurum ve kuruluşlar
              </td>
              <td className="border border-gray-300 p-2">
                Görsel ve İşitsel Kayıtlar: CCTV Kamera Kaydı
              </td>
              <td className="border border-gray-300 p-2">
                Yasal düzenlemeler ve mevzuat gereği bilgi verilmesi
              </td>
            </tr>
          </tbody>
        </table>

        <h2 className="text-xl font-semibold mb-4">
          d) Kişisel Veri Sahibi Olarak KVKK Kapsamındaki Haklarınızla İlgili
          Bilgilendirme
        </h2>
        <p className="mb-6">
          Kişisel veri sahibi olarak, KVKK’nın ilgili kişinin haklarını
          düzenleyen 11. maddesi kapsamındaki haklarınızı Veri Sorumlusuna
          Başvuru Usul ve Esasları Hakkında Tebliğ’e göre kullanmak için{" "}
          <strong>
            Kaptanpaşa Mahallesi Halit Ziya Türkkan Sokak No: 19/1
            Şişli/İSTANBUL
          </strong>{" "}
          adresine yazılı olarak iletebilir veya{" "}
          <strong>kvkk@lensa.com.tr</strong> e-posta adresine e-posta yoluyla
          veya <strong>lensa.bilisim@hs01.kep.tr</strong> kayıtlı elektronik
          posta (KEP) adresine iletebilirsiniz.
        </p>
      </div>
    </div>
  );
};

export default Camera;
